import React from 'react';
import { Form, Modal } from "react-bootstrap";
import { Controller, useForm } from 'react-hook-form';
import LoadingButtonWithForm from '../../components/LoadingButtonWithForm';
import { responseError } from '../../helpers/responseHandler';
import { useAddAlertMutation } from '../../redux/services/AlertService';
import { sweetAlert } from '../../utils';

const AlertCompanyModal = ({ show, handleClose, isEdit }) => {
    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()


    const [addRequest, { isLoading: addLoading }] = useAddAlertMutation()


    const onSubmit = async (data) => {
        data['is_client_email'] = 0
        data['is_client_sms'] = 0
        const newForm = { ...data }
        await addRequest(newForm).unwrap()
            .then((res) => {
                if (res?.status) {
                    sweetAlert(res?.message, 'success')
                    handleClose()
                    // navigate(-1)
                }
            })
            .catch((err) => {
                responseError(err)
            })
    }

    return (
        <>
            <Modal show={show} onHide={handleClose}>

                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Create Alert</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)} id='driver-status'>
                        <Form.Group className="mb-3">
                            <Form.Label>Name:</Form.Label>
                            <Controller
                                name="name"
                                control={control}
                                defaultValue={isEdit?.name || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="text" placeholder="Enter Name"
                                        isInvalid={errors.name}
                                    />
                                )}
                            />
                        </Form.Group>
                    </Form>
                    <div className="row">

                        <div className="col-md-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Message:</Form.Label>
                                <Controller
                                    name="message"
                                    control={control}
                                    defaultValue={isEdit?.message || ''}
                                    rules={{
                                        required: true
                                    }}
                                    render={({ field }) => (
                                        <Form.Control
                                            {...field}
                                            as="textarea"
                                            placeholder="Enter your message"
                                            rows={3}
                                            isInvalid={errors.message}
                                        />
                                    )}
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group className="mb-3">
                                <Form.Label>Expiry Date:</Form.Label>

                                <Controller
                                    name="expiry"
                                    control={control}
                                    defaultValue={isEdit?.expiry || ''}
                                    rules={{
                                        required: true
                                    }}
                                    render={({ field }) => (
                                        <Form.Control
                                            {...field}
                                            type="date"
                                            isInvalid={errors.expiry}
                                        />
                                    )}
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group className="mb-3">
                                <Form.Label>Minus Reminder Date:</Form.Label>
                                <Controller
                                    name="minus_days"
                                    control={control}
                                    defaultValue={isEdit?.minus_days || ''}
                                    rules={{
                                        required: true
                                    }}
                                    render={({ field }) => (
                                        <Form.Control
                                            {...field}
                                            as={'select'}
                                            isInvalid={errors.minus_days}
                                        >
                                            <option value="">Please Select</option>
                                            <option value="0">0</option>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="30">30</option>
                                        </Form.Control>
                                    )}
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Send Notification to System:</Form.Label>
                                <div className="d-flex">
                                    <Controller
                                        name='is_system_sms'
                                        control={control}
                                        defaultValue={isEdit?.is_system_sms || false}
                                        render={({ field }) => (
                                            <Form.Check
                                                {...field}
                                                type="checkbox"
                                                label="SMS"
                                                className="me-3"
                                            />
                                        )}
                                    />
                                    <Controller
                                        name='is_system_email'
                                        control={control}
                                        defaultValue={isEdit?.is_system_email || false}
                                        render={({ field }) => (
                                            <Form.Check
                                                {...field}
                                                type="checkbox"
                                                label="Email"
                                                className='me-3'
                                            />
                                        )}
                                    />
                                    <Controller
                                        name='is_system_notification'
                                        control={control}
                                        defaultValue={isEdit?.is_system_notification || false}
                                        render={({ field }) => (
                                            <Form.Check
                                                {...field}
                                                type="checkbox"
                                                label="Notification"
                                            />
                                        )}
                                    />
                                </div>
                            </Form.Group>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <LoadingButtonWithForm
                        isLoading={addLoading}
                        name="Save"
                        form="driver-status"
                    />
                </Modal.Footer>


            </Modal>
        </>
    );
};

export default AlertCompanyModal;